import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Subcontractor } from './../../../../../_shared/model/subcontractor.model';
import { SetCalendarSubcontractors } from './../../../../../_shared/state/base/base.actions';
import { BaseState } from './../../../../../_shared/state/base/base.state';
import { AvailabilityReportPopupComponent } from './../../../../components/term/availability-report-popup/availability-report-popup.component';

@Component({
    selector: 'main-cal-subc',
    templateUrl: './main-cal-subc.component.html',
    styles: [],
})
export class MainCalSubcComponent implements OnInit {
    constructor(
        private store: Store,
        private modalService: NgbModal,
    ) {
        this.popUpOpened = new EventEmitter();
    }
    private onDestroy$ = new Subject<void>();
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public guiSettings: any;

    @Select(BaseState.GetUserSettings)
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    userSettings: Observable<any>;

    @Input()
    public allSubcontractors: Subcontractor[];

    @Output()
    public popUpOpened: EventEmitter<boolean>;

    public selectedSubconstractors: Subcontractor[] = [];

    ngOnInit() {
        this.userSettings.pipe(takeUntil(this.onDestroy$)).subscribe(res => {
            if (res) {
                this.guiSettings = res.calendar;
                this.selectedSubconstractors = this.guiSettings.subconstractors;
            }
        });
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public reloadEventsPublic(data: any) {
        // data -> selectedSubcontractors
        this.selectedSubconstractors = data;
        this.store.dispatch(new SetCalendarSubcontractors(this.selectedSubconstractors));
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    public openAvailabilityReportPopup(): void {
        const modalNewTerm = this.modalService.open(AvailabilityReportPopupComponent, {
            keyboard: true,
            windowClass: 'mf-transparent-popup mf-gray-background-popup mf-screen-height-popup mf-popup-with__title',
        });
        this.popUpOpened.emit(true);
        modalNewTerm.result.then(
            () => {
                this.popUpOpened.emit(false);
            },
            () => {
                this.popUpOpened.emit(false);
            },
        );
    }
}
